<div>
    <mat-horizontal-stepper [linear]="true" >
        <mat-step  [state]="home">
            <ng-template matStepLabel>Home</ng-template>
        </mat-step>
        <mat-step completed='false' editable='false' [state]="Cart">
            <ng-template matStepLabel>Cart</ng-template>
        </mat-step>
        <mat-step [state]="Profile">
            <ng-template matStepLabel>Profile</ng-template>
        </mat-step>
        <mat-step [state]="Checkout">
            <ng-template matStepLabel>Checkout</ng-template>
        </mat-step>
        <mat-step [state]="done">
            <ng-template matStepLabel>Done</ng-template>
        </mat-step>

        <!-- Icon overrides. -->
        <ng-template matStepperIcon="home">
            <mat-icon>home</mat-icon>
        </ng-template>
        <ng-template matStepperIcon="Cart">
            <mat-icon>shopping_basket</mat-icon>
        </ng-template>
        <ng-template matStepperIcon="Profile">
            <mat-icon>perm_identity</mat-icon>
        </ng-template>
        <ng-template matStepperIcon="Checkout">
            <mat-icon>forum</mat-icon>
        </ng-template>
        <ng-template matStepperIcon="done">
            <mat-icon>check_circle_outline</mat-icon>
        </ng-template>

    </mat-horizontal-stepper>
</div>
